import React, { useEffect, useState } from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';
import { colors } from '@skyslope/mache';
import { useShallowSelector } from '../../lib/reduxHooks';
import type { IRootState } from '../../store';

const useStyles = makeStyles(() => ({
  wrapper: {
    color: colors.grey[600],
    // This is intended to sit on top of the header bar, and the .MuiAppBar-root class has z-index: 1100
    zIndex: 1100,
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    marginRight: '20px',
  },
}));

interface IState {
  isAutoSaving: undefined | boolean;
  errorShow: boolean;
}

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const selector = (state: IRootState) => ({
  isAutoSaving: state.senderBuild.isAutoSaving,
  errorShow: state.pageFrame.errorShow,
});

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const AutoSaveIndicator = () => {
  const { isAutoSaving, errorShow }: IState = useShallowSelector(selector);
  const classes = useStyles();
  const [isHidden, setIsHidden] = useState(true);
  const [error, setError] = useState(errorShow);

  useEffect(() => {
    if (!isAutoSaving) {
      const timer = setTimeout(() => {
        setIsHidden(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
    setIsHidden(false);
  }, [isAutoSaving]);

  useEffect(() => {
    if (!errorShow) {
      setError(false);
    } else {
      setError(true);
    }
  }, [errorShow]);

  return (
    <>
      {!isHidden && !error && (
        <div className={classes.wrapper}>
          <Typography variant="body1">{isAutoSaving ? 'Saving Changes...' : 'All Changes Saved!'}</Typography>
        </div>
      )}
    </>
  );
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default AutoSaveIndicator;
